import { render, staticRenderFns } from "./CellRendererRelation.vue?vue&type=template&id=2ba183c7&"
import script from "./CellRendererRelation.vue?vue&type=script&lang=js&"
export * from "./CellRendererRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports